import request from "./http";
import qs from 'qs'
// /**
// 	 * 单位用户树
// 	 */
export function statementVariableTree(params) {
    return request({
        url: "/statement/variable/tree",
        method: "get",
        params
    });
}

// /**
// 	 * 统计报表-获取应用类型组列表
// 	 */
export function statementAppTypeGroup() {
    return request({
        url: "/statement/appTypeGroup",
        method: "get",
    });
}


// /**
// 	 * 统计报表-根据用户id获取目录树
// 	 */
export function statementFindTree() {
    return request({
        url: "/statement/findTree/byUserId",
        method: "get",
    });
}
// /**
// 	 * 统计报表-根据目录id获取记录信息
// 	 */
export function statementFindTreefindDataByCatalogueId(params) {
    return request({
        url: "/statement/findDataByCatalogueId",
        method: "get",
        params
    });
}

// /**
// 	 * 统计报表-根据目录id获取记录信息
// 	 */
export function statementfindDataByCatalogueId(params) {
    return request({
        url: "/statement/findDataByCatalogueId",
        method: "get",
        params
    });
}

// /**
// 	 * 统计报表-保存目录或模板数据
// 	 */
export function statementSave(data) {
    return request({
        url: "/statement/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
          data
    });
}

// /**
// 	 * 统计报表-根据id加载模板数据
// 	 */
export function statementFindById(params) {
    return request({
        url: "/statement/findById",
        method: "get",
        params
    });
}

// /**
// 	 * 统计报表-根据id删除数据-或目录
// 	 */
export function statementDeleteById(params) {
    return request({
        url: "/statement/deleteById",
        method: "delete",
        params
    });
}

// /**
// 	 * 统计报表-获取报表数据集(年月日通用)
// 	 */
export function statementVariableData(data) {
    return request({
        url: "/statement/variable/data",
        method: "post",
        headers:{
            'Content-Type':'application/json',
          },
        data
        
    });
}



